import { Box, Typography, Divider, Modal } from '@mui/material';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { RADIUS } from '../../../layouts/dashboard/config-layout';
import { useEffect } from 'react';
import DepartmentController from '../controller/department.controller';
import CusttomAlertController from '../../../alert/controller/custom.alert.controller';
import CustomAlertModal from '../../../alert/components/custom.alert.modal';
import DepartmentHeader from './components/department.header';
import DepartmentTable from './components/department.table';
import DepartmentModalCreate from './components/department.modal.create';
import DepartmentModalUpdate from './components/department.modal.update';
import useScreenWidth from '../../../hooks/use-page-width';

const DepartmentPage = () => {
  const ctrl = DepartmentController();
  const alert = CusttomAlertController();
  const width = useScreenWidth();

  useEffect(() => {
    ctrl.getData(true, ctrl.filter);
  }, []);

  const modalContent =
    ctrl.activeModal?.name === 'CREATE' ? (
      <DepartmentModalCreate
        loading={ctrl.loading}
        message={ctrl.message}
        onClose={() => ctrl.onHandleModal(null)}
        onSubmit={ctrl.onSubmitCreate.bind(ctrl)}
      />
    ) : ctrl.activeModal?.name === 'UPDATE' ? (
      <DepartmentModalUpdate
        loading={ctrl.loading}
        message={ctrl.message}
        defaultValues={ctrl.formUpdate}
        onClose={() => ctrl.onHandleModal(null)}
        onSubmit={ctrl.onSubmitUpdate.bind(ctrl)}
      />
    ) : null;

  return (
    <>
      <Typography sx={{ px: 3, py: 2, color: '#f5f4f4' }}>ຈັດການກົມ</Typography>

      <Box sx={{ px: width > 600 ? 3 : 0, paddingBottom: '15px' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f5f4f4',
            borderTopLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderTopRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomLeftRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
            borderBottomRightRadius: width > 600 ? RADIUS.BORDERRADIUS : 0,
          }}
        >
          <DepartmentHeader
            filter={ctrl.filter}
            onFilterChange={ctrl.onFilterChange.bind(ctrl)}
            handleOpenDialog={() => ctrl.onHandleModal({ name: 'CREATE' })}
          />

          <Divider sx={{ backgroundColor: '#D9D9D9' }} />

          <Typography
            fontSize={18}
            sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', p: 3 }}
          >
            <ApartmentOutlinedIcon />
            <Typography marginLeft="10px">ຈັດການກົມ</Typography>
          </Typography>

          <DepartmentTable ctrl={ctrl} alert={alert} />
        </Box>
      </Box>

      <Modal
        open={ctrl.activeModal != null}
        onClose={() => ctrl.onHandleModal(null)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
      >
        <Box
          sx={{
            bgcolor: 'white',
            width: '100%',
            maxWidth: '900px',
            borderRadius: '12px',
            maxHeight: { xs: '90vh', md: '800px' },
            overflow: 'hidden',
          }}
        >
          {modalContent}
        </Box>
      </Modal>

      <CustomAlertModal ctrl={alert} />
    </>
  );
};

export default DepartmentPage;
